import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [hideMenu, setHideMenu] = useState(false);

  return (
    <main className="flex h-auto flex-wrap bg-background" >
      <div className="flex gap-6 h-auto bg-background-dark" style={{maxHeight:'100vh'}}>
        <Sidebar setHideMenu={setHideMenu} hideMenu={hideMenu} />
      </div>
      <div className='flex flex-col flex-1 shrink  self-stretch basis-0 min-w-60 max-md:px-5 bg-background-dark' style={{maxHeight:'100vh',overflowY:'scroll'}}>
     {children}

      </div>
    </main>
  );
  
  // return (
  //   <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

  //     {/* Container principal */}
  //     <Box sx={{ display: 'flex', flex: 1 }}>
  //       {/* Área de conteúdo */}
  //       <Box 
  //         component="main" 
  //         sx={{ 
  //           flex: 1,
  //           backgroundColor: '#f4f4f4',
  //           minHeight: '100vh',
  //           padding: '20px',
  //           marginLeft: '240px', // largura do Drawer do Navbar
  //         }}
  //       >
  //         {children}
  //       </Box>
  //     </Box>
  //   </Box>
  // );
};

export default Layout; 